var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7H13C12.4 7 12 7.4 12 8C12 8.6 12.4 9 13 9H15C15.6 9 16 9.4 16 10V17C16 17.6 15.6 18 15 18H3C2.4 18 2 17.6 2 17V10C2 9.4 2.4 9 3 9H5C5.6 9 6 8.6 6 8C6 7.4 5.6 7 5 7H3C1.3 7 0 8.3 0 10V17C0 18.7 1.3 20 3 20H15C16.7 20 18 18.7 18 17V10C18 8.3 16.7 7 15 7ZM5.3 12.7L8.3 15.7C8.5 15.9 8.7 16 9 16C9.3 16 9.5 15.9 9.7 15.7L12.7 12.7C13.1 12.3 13.1 11.7 12.7 11.3C12.3 10.9 11.7 10.9 11.3 11.3L10 12.6V1C10 0.4 9.6 0 9 0C8.4 0 8 0.4 8 1V12.6L6.7 11.3C6.3 10.9 5.7 10.9 5.3 11.3C4.9 11.7 4.9 12.3 5.3 12.7Z",
    fill: "#8D9298"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImportIcon);
export default __webpack_public_path__ + "static/media/importIcon.8a05ddb3.svg";
export { ForwardRef as ReactComponent };